import { ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { FirewallAdvancedRule, FirewallAdvancedRuleFormValue, FirewallAdvancedRuleType } from '@nirvana/shared/dtos/types/policies/common';
import { universalAbsoluteFilePath } from '../../../../../../common/policyPanel/uiSettings/utils/validators/path.validators';

// see universalAbsoluteFilePathForFirewallRules from ExtJs
export async function validateUniversalAbsoluteFilePathForFirewallAdvancedRules(
  value: string
): Promise<ValidationResult> {
  if (!value) {
    return { valid: true };
  }

  if (value.toLowerCase() === 'system') {
    return { valid: true };
  }

  return await universalAbsoluteFilePath(value);
}

// validate duplicates
export function validateDuplicates(
  ruleItem: FirewallAdvancedRuleFormValue,
  rulesInGrid: FirewallAdvancedRule[]
): ValidationResult {
  const hasDuplicates = rulesInGrid.some(
    (ruleInGrid: FirewallAdvancedRule) => ruleInGrid.details.name === ruleItem.details.name
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}

/**
 * A rule is broken if it has md5 and no path
 * @param {FirewallAdvancedRule} rule
 * @return {boolean}
 */
export function isBrokenRule(rule: FirewallAdvancedRule): boolean {
  return !!(rule.ruleType === FirewallAdvancedRuleType.APPLICATION && rule.details.applicationMd5 && !rule.details.applictionPath);
}
